/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ConfirmedActionItem
 */
export interface ConfirmedActionItem {
  /**
   *
   * @type {string}
   * @memberof ConfirmedActionItem
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ConfirmedActionItem
   */
  assignee: string;
  /**
   *
   * @type {LocalDate}
   * @memberof ConfirmedActionItem
   */
  deadline?: LocalDate | null;
}

/**
 * Check if a given object implements the ConfirmedActionItem interface.
 */
export function instanceOfConfirmedActionItem(
  value: object,
): value is ConfirmedActionItem {
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("assignee" in value) || value["assignee"] === undefined) return false;
  return true;
}

export function ConfirmedActionItemFromJSON(json: any): ConfirmedActionItem {
  return ConfirmedActionItemFromJSONTyped(json, false);
}

export function ConfirmedActionItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConfirmedActionItem {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    assignee: json["assignee"],
    deadline: json["deadline"] == null ? undefined : json["deadline"],
  };
}

export function ConfirmedActionItemToJSON(json: any): ConfirmedActionItem {
  return ConfirmedActionItemToJSONTyped(json, false);
}

export function ConfirmedActionItemToJSONTyped(
  value?: ConfirmedActionItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    assignee: value["assignee"],
    deadline: value["deadline"],
  };
}
